import Vue from 'vue'
import Router from 'vue-router'
import Paytable from '../components/PaytableGame.vue'
import RuleGame from '../components/RuleGame.vue'
import ResultGame from '../components/ResultGame.vue'
import WebLayout from '../components/WebLayout.vue'
import HyperMode from '../components/HyperMode.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: WebLayout,
      children: [

        {
          name: 'paytable-game',
          path: '/paytable',
          component: Paytable,
        },
        {
          name: 'rulegame',
          path: '/rule',
          component: RuleGame,
        },
        {
          name: 'result-game',
          path: '/result',
          component: ResultGame,
        },
        {
          name: 'hypermode',
          path: '/hypermode',
          component: HyperMode,
        },
      ]
    },
    {
      path: '*',
      redirect: '/paytable'
    }
  ]
})